import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Stats from "./pages/Stats";
import "./style.scss";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";

function App() {
  const { currentUser, loading } = useContext(AuthContext);
  // const [mood, setMood] = useState("");

  // useEffect(() => {
  //   axios.get("/api").then((res) => setMood(res.data));
  // }, []);

  // console.log(mood);

  const ProtectedRoute = ({ children }) => {
    // Wait for "usthe auth state to resolve before deciding where to navigate
    if (loading) return <div className="loader"/>;

    if (!currentUser) {
      return <Navigate to="/login" />;
    }

    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route
            index
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route
            path="stats"
            element={
              <ProtectedRoute>
                <Stats />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
